import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { SystemApi } from "features/brm";

/**
 * Sets the IsOutput of an Datatype
 *
 * @param {string} dataTypeId - uuid of the dataType
 * @param {string} isOutput - new isOutput of the dataType
 */
export const setDataTypeIsOutput = ({ dataTypeId, isOutput }) => {
  return Brm.dataTypeApi.setDataTypeIsOutput(dataTypeId, { body: isOutput });
};

/**
 * Custom hook to change the IsOutput of an existing datatype
 *
 * @param {object} config - react-query configuration object
 * @returns react-query ReactQuery.useMutation
 */
export const useSetDataTypeIsOutput = ({ projectId, config = {} } = {}) => {
  const queryClient = ReactQuery.useQueryClient();

  return ReactQuery.useMutation({
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.project(projectId));
      queryClient.invalidateQueries(SystemApi.dataTypeKeys.dataType(variables.dataTypeId));
    },
    ...config,
    mutationFn: setDataTypeIsOutput,
  });
};
